<script setup lang="ts">
	defineProps({
		error: Object
	})

	function handleError() {
		clearError({ redirect: '/' })
	}
</script>

<template>
	<nuxt-layout>
		<div class="relative px-4 font-sans">
			<div class="error-wrapper">
				<div class="error-container">
					<div class="error">
						<h3 class="text-sm sm:text-lg"> Oops! Something Went Wrong </h3>
						<h1>
							<span v-for="(item, index) in String(error?.statusCode || '')" :key="index">{{
								item
							}}</span>
						</h1>
					</div>
					<h2>{{ error?.message }}</h2>
				</div>
				<button
					class="default-btn w-full max-w-[300px] justify-center !rounded-md bg-primary-800 text-white hover:bg-primary-700 xl:mt-10"
					@click="handleError"
				>
					Go Home
				</button>
			</div>
		</div>
	</nuxt-layout>
</template>

<style scoped>
	.error-wrapper {
		@apply relative flex h-[100vh] flex-col items-center justify-center;
	}

	.error-container {
		max-width: 520px;
		width: 100%;
		line-height: 1.4;
		text-align: center;
	}

	.error-container .error {
		position: relative;
		@apply relative min-h-[220px] sm:min-h-[240px] xl:min-h-[350px];
	}

	.error-container .error h1 {
		position: absolute;
		left: 50%;
		top: 50%;
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		@apply m-0 -ml-[20px] text-[10rem] font-[900] uppercase -tracking-[40px] text-primary-900 sm:text-[15rem] xl:text-[20rem];
	}

	.error-container .error h1 > span {
		text-shadow: -8px 0px 0px #fafafa;
	}

	.error-container .error h3 {
		@apply relative m-0 pl-[6px] font-[700] uppercase tracking-[3px] text-blue-950 sm:text-base;
	}

	.error-container h2 {
		@apply mb-[25px] mt-0 text-sm font-normal uppercase text-blue-950 sm:text-lg xl:text-2xl;
	}
</style>
